import React from 'react';
import { useTranslation } from 'react-i18next';

import { BenefitCard } from './BenefitCard';

export const PostpartumBenefits = () => {
  const { t } = useTranslation();

  return (
    <section className="index-screen__benefits">
      <h2 className="index-screen__benefits_title">{t('evieOnboarding.indexScreen.benefits.postpartum.title')}</h2>
      <BenefitCard>
        <p className="index-screen__benefitcard_content">{t('evieOnboarding.indexScreen.benefits.postpartum.card1')}</p>
      </BenefitCard>
      <BenefitCard>
        <p className="index-screen__benefitcard_content">{t('evieOnboarding.indexScreen.benefits.postpartum.card2')}</p>
      </BenefitCard>
      <BenefitCard>
        <p className="index-screen__benefitcard_content">{t('evieOnboarding.indexScreen.benefits.postpartum.card3')}</p>
      </BenefitCard>
      <BenefitCard>
        <p className="index-screen__benefitcard_content">{t('evieOnboarding.indexScreen.benefits.postpartum.card4')}</p>
      </BenefitCard>
    </section>
  );
};
